export const POPUP_CONSTANTS = {
  addNumberPopup: 'addNumberPopup',
  invitationSuccessPopup: 'invitationSuccessPopup',
  invitationErrorPopup: 'invitationErrorPopup',
  errorDescriptionPopup: 'errorDescriptionPopup',
};

export const ERROR_POPUP_TYPES = {
  SMT_GOING_WRONG: 'SMT_GOING_WRONG',
  CTN_NOT_FOUND: 'CTN_NOT_FOUND',
  DIFFERENT_REGIONS_ABONENT: 'DIFFERENT_REGIONS_ABONENT',
  INVALID_QUERY_PARAM: 'INVALID_QUERY_PARAM',
};

export const INVITATION_STATUS = {
  sent: 'Sent',
  confirmed: 'Confirmed',
};

export const PHONE_MASK = '+7 ### ###-##-##';

export const FAMILY_URL = '/limited-family';
